import validate from "../../util/formValidationMethods";

export function validateInput(inputVal, statePropertyKey) {
  switch (statePropertyKey) {
    case "name":
      return validate.name(inputVal);
    case "email":
      return validate.email(inputVal);
    case "title":
      return validate.hasText(inputVal);
    case "description":
      return validate.hasText(inputVal);
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/Video/config/validateInput.js